import React, { useContext, useState } from "react";
import { AppContextProvider } from "../App";
import Logo from '../assets/Logo.svg'
const Reset = () => {
  const [email, setEmail] = useState("");
  const { setResetSent } = useContext(AppContextProvider);

  const handleSubmit = () => {
    localStorage.setItem("resent", "true");
  };
  return (
    <form className="relative max-w-sm px-4 pt-20 pb-10 mx-auto mb-5 text-center lg:pt-40">
       <a href="/" className=" text-3xl text-center flex justify-center">
          <img className="w-[56px]" src={Logo} alt="" />
        </a>
      <h1 className="py-5 text-[28px] md:text-[32px]">Forgot Password?</h1>
      <p className="text-xs pb-5 w-[90%] mx-auto">
        Enter the email address associated with your account and we will send
        you a link to reset your password.
      </p>
      <div className="mb-5">
        <label
          for="email"
          className="block mb-2 text-sm font-medium text-left text-gray-900 dark:text-white"
        >
          Email address
        </label>
        <input
          onChange={(e) => setEmail(e.target.value)}
          value={email}
          placeholder="e.q johnatan@doe.com"
          type="email"
          id="email"
          className="text-md dark:text-white dark:border-gray-500  dark:bg-transparent focus:bg-white bg-[#F8F8F8] border border-gray-300 text-gray-900 rounded-lg focus:ring-black outline-black focus:border-black block w-full p-2.5"
          required
        />
      </div>
      <a
        href="/Pages/Registration"
        onClick={handleSubmit}
        type="submit"
        className="w-full px-5 py-4 dark:bg-white dark:text-black text-sm font-medium text-center text-white bg-[#1c1c1c] rounded-lg hover:text-black hover:bg-white/40 hover:border-2 focus:ring-4 focus:outline-none focus:ring-white"
      >
        Request password reset
      </a>
    </form>
  );
};
export default Reset;
